import React, {
  useEffect, useMemo, useRef, useState,
} from 'react';
import ScheduleListHeader from './ScheduleListHeader';
import ScheduleListItem from './ScheduleListItem';
import useWindowDimensions from '../../../../hooks/useWindowDimensions';
import ScheduleListMobileItem from './ScheduleListMobileItem';

function ScheduleList({ schedules, stationsMap }) {
  const { width } = useWindowDimensions();
  const schedulesRef = useRef(null);
  const [isRefInitialized, setIsRefInitialized] = useState(false);

  useEffect(() => {
    if (schedulesRef.current) {
      setIsRefInitialized(true); // Trigger any actions dependent on the ref being set
    }
  }, [schedulesRef.current]); // Watch for changes to the ref

  const containerWidth = useMemo(
    () => schedulesRef?.current?.clientWidth,
    [width, isRefInitialized],
  );

  return (
    <div className="lg:overflow-x-auto" ref={schedulesRef}>
      <div className="flex flex-col gap-3 lg:min-w-[1024px]">
        <ScheduleListHeader />
        <div className="w-full bg-white h-[2px]" />
        {schedulesRef?.current && schedules?.map(
          (schedule) => (
            <React.Fragment key={schedule.id}>
              {width > 1024 ? (
                <ScheduleListItem
                  schedule={schedule}
                  containerWidth={containerWidth}
                  stationsMap={stationsMap}
                />
              )
                : <ScheduleListMobileItem schedule={schedule} stationsMap={stationsMap} />}
            </React.Fragment>
          ),
        )}
      </div>
    </div>
  );
}

export default ScheduleList;
